var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('LedButton',{attrs:{"txt":"Set"},on:{"clicked":_vm.send}}),_c('ColorPicker',{on:{"input":function($event){_vm.color = $event.rgba}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }